// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SidebarPanelLogo__logo-f85564 {
  display: flex;
  cursor: pointer;
  width: 100%;
  height: 72px;
  justify-content: center;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/main/SidebarPanel/SidebarPanelNavigation/SidebarPanelLogo/SidebarPanelLogo.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;AACF","sourcesContent":[".logo {\n  display: flex;\n  cursor: pointer;\n  width: 100%;\n  height: 72px;\n  justify-content: center;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logo": `SidebarPanelLogo__logo-f85564`
};
module.exports = ___CSS_LOADER_EXPORT___;
